export default "__VITE_ASSET__C5aZb$Nd__"